import BModal from '@/components/compat/BModal.vue'
import BDropdown from '@/components/compat/BDropdown.vue'
import BDropdownItem from '@/components/compat/BDropdownItem.vue'
import BButton from '@/components/compat/BButton.vue'
import BCard from '@/components/compat/BCard.vue'
import BTabs from '@/components/compat/BTabs.vue'
import BTab from '@/components/compat/BTab.vue'

export function registerBootstrapCompat (app) {
  app.component('BModal', BModal)
  app.component('b-modal', BModal)
  app.component('BDropdown', BDropdown)
  app.component('BDropdownItem', BDropdownItem)
  app.component('BButton', BButton)
  app.component('BCard', BCard)
  app.component('b-card', BCard)
  app.component('BTabs', BTabs)
  app.component('BTab', BTab)
}
